<div class="flex text-center mb-8 bg-white">
  <div class="stat-block flex-1" [class.active]="activeFilter === null && !hasOtherFiltersActive" (click)="filterChange.emit(null)">
    <nz-statistic [nzValue]="(totalSms | number)!" nzTitle="Total SMS"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'sent'" (click)="filterChange.emit('sent')">
    <nz-statistic [nzValue]="(smsSent | number)!" nzTitle="SMS Sent"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'delivered'" (click)="filterChange.emit('delivered')">
    <nz-statistic [nzValue]="(smsDelivered | number)!" nzTitle="Delivered"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'failed'" (click)="filterChange.emit('failed')">
    <nz-statistic [nzValue]="(smsFailed | number)!" nzTitle="Failed"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'error'" (click)="filterChange.emit('error')">
    <nz-statistic [nzValue]="(smsError | number)!" nzTitle="SMS Error"></nz-statistic>
  </div>
  <!-- Not clickable: Total Credit Used is a sum, not a boolean-flag status
       category, so there's no sensible "records where this is true" filter. -->
  <div class="stat-block flex-1 non-interactive">
    <nz-statistic [nzValue]="(totalCreditUsed | number)!" nzTitle="Total Credit Used"></nz-statistic>
  </div>
</div>
